import { Box, Button, FormControlLabel, Grid, GridRow, ModalDialog, Switch, Text } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [customHeader, setCustomHeader] = useState(false);
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);
	const onButton = () => setOpen(true);
	const onSwitch = (event: object, value: boolean) => setCustomHeader(value);

	return (
		<Box>
			<Button design="primary" onClick={onButton}>
				Custom Modal Dialog
			</Button>
			<ModalDialog
				onClose={onClose}
				open={open}
				showDividers
				title="Dialog Title"
			>
				{{
					buttons: (
						<GridRow justifyContent="flex-end" spacing={2}>
							<Button design="secondary" onClick={onClose}>Save &amp; New</Button>
							<Button design="primary" onClick={onClose}>Save</Button>
							<Button design="link" onClick={onClose}>Cancel</Button>
						</GridRow>
					),
					header: customHeader && (
						<Text text="Custom Header" variant="h2" />
					),
					main: (
						<FormControlLabel
							control={<Switch checked={customHeader} onChange={onSwitch} />}
							label="Custom header"
							labelPlacement="start"
						/>
					),
				}}
			</ModalDialog>
		</Box>
	);
};